import { map } from 'lodash/fp';
import { shallowEqual, useSelector } from 'react-redux';
import Icon from '@ahmdigital/icons-web';

import { STEP_DEFINITIONS } from '../../../constants';
import { StepName, StepNumber, StepWrapper, StyledClickable } from '../styles';
import { useByocNavigationContext } from '../../../context/byoc-navigation-context';
import uncapFpIterator from '../../../../../../utils/uncap-fp-iterator';
import type { RootState } from '../../../../../reducers';
import type { StepSlug } from '../../../types';

const mapWithIndex = uncapFpIterator(map);

type Props = {
  handleGoToStep: (slug: StepSlug) => void;
  isMobile?: boolean;
};

const StepNavigation = ({ isMobile = false, handleGoToStep }: Props) => {
  const { activeIndex, activeSlug, stepSlugs } = useByocNavigationContext();
  const completedSteps = useSelector(
    (state: RootState) =>
      Object.fromEntries(stepSlugs.map((slug) => [slug, STEP_DEFINITIONS[slug].isCompleted?.(state) ?? false])),
    shallowEqual,
  );

  return (
    <>
      {mapWithIndex((slug: StepSlug, index: number) => {
        const isActive = slug === activeSlug;
        const isAfterActiveStep = index > activeIndex;
        const isCompleted = Boolean(completedSteps[slug]) && !isActive;
        const stepNumber = index + 1;
        return (
          <StepWrapper key={slug} isMobile={isMobile}>
            <StyledClickable disabled={isAfterActiveStep} isUnstyled onClick={() => handleGoToStep(slug)}>
              <StepNumber $isActive={isActive} $isCompleted={isCompleted}>
                {isCompleted ? <Icon name="tick" width={12} height={12} /> : stepNumber}
              </StepNumber>
              <StepName $isActive={isActive} $isCompleted={isCompleted}>
                {STEP_DEFINITIONS[slug].label}
              </StepName>
            </StyledClickable>
          </StepWrapper>
        );
      }, stepSlugs)}
    </>
  );
};

export default StepNavigation;
